import React from 'react';
import { BrainIcon, ChartNoAxesColumnIcon, ClipboardCheckIcon, FileTextIcon, MapIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { extras } from '../../data/lists';
const icons = [FileTextIcon, ClipboardCheckIcon, BrainIcon, ChartNoAxesColumnIcon, MapIcon];
export function Extras() {
  return <section className="bg-forest px-4 py-16 sm:py-20" data-id="element-139" data-mp="3cgk19yg5fwtg">
      <div className="mx-auto max-w-3xl" data-id="element-140" data-mp="3cf0hvyz755ng">
        <SectionHeading tone="dark" title="And that's not all…" sub="Inside your system you'll also receive:" data-id="element-141" data-mp="37hqvks73ta3u" />

        <ul className="mt-10 space-y-3" data-id="element-142" data-mp="3lhrui23t67go">
          {extras.map((e, i) => {
          const Icon = icons[i];
          return <li key={e.title} className="flex items-start gap-4 rounded-2xl bg-forest-700 p-4 sm:p-5" data-id="element-143" data-mp="3gioqmkzke7aa" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-cream text-forest" data-id="element-144" data-mp="1r3qv9g4cjig2">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-145" data-mp="1m6ienjyujmgx" />
                </span>
                <div data-id="element-146" data-mp="w1bvosea3zlb">
                  <h3 className="text-base font-extrabold uppercase tracking-wide text-cream" data-id="element-147" data-mp="10yll481o4b95">{e.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-cream/80" data-id="element-148" data-mp="15xyi3lm96ypg">{e.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-cream/90" data-id="element-149" data-mp="1aqhvahh13rtq">
          At the end of the 21 days, you won't simply have more information sitting inside another PDF.{' '}
          <strong className="text-cream" data-id="element-150" data-mp="1jqwixnhgtj0e">You'll have a documented practice journey you can continue building on.</strong>
        </p>

        <div className="mt-10" data-id="element-151" data-mp="1tnsslwj3ob6j">
          <CTAButton tone="dark" label="Yes! I want the complete 21-day system" note="Only $27 · Lifetime access" data-id="element-152" data-mp="1tly4k9cj82y8" />
        </div>
      </div>
    </section>;
}